import { api } from '../utils/api.js';

export const daily = () => ({
  loading: false,
  error: null,
  successMessage: null,
  currentStreak: 1, // TODO: Track actual streak
  recentClaims: [], // TODO: Load from localStorage

  // Initialize component
  init() {
    console.log('Daily component initialized');
    this.loadRecentClaims();
    this.clearMessages();
  },

  // Clear messages after timeout
  clearMessages() {
    setTimeout(() => {
      this.error = null;
      this.successMessage = null;
    }, 5000);
  },

  // Load recent claims from localStorage
  loadRecentClaims() {
    try {
      const stored = localStorage.getItem('daily:recentClaims');
      if (stored) {
        this.recentClaims = JSON.parse(stored).slice(0, 5); // Keep only last 5
      }
    } catch (error) {
      console.warn('Failed to load recent daily claims:', error);
      this.recentClaims = [];
    }
  },

  // Save recent claim to localStorage
  saveRecentClaim(claimData) {
    try {
      const newClaim = {
        date: new Date().toISOString(),
        description: claimData.description,
        coins: claimData.coins,
        item: claimData.item
      };
      
      this.recentClaims.unshift(newClaim);
      this.recentClaims = this.recentClaims.slice(0, 5); // Keep only last 5
      
      localStorage.setItem('daily:recentClaims', JSON.stringify(this.recentClaims));
    } catch (error) {
      console.warn('Failed to save recent daily claim:', error);
    }
  },

  // Check if daily reward can be claimed
  canClaim() {
    const store = this.$store.app;
    
    if (!store.hasPlayer()) return false;
    const player = store.p();
    
    if (!player.lastDailyAt) {
      return true; // Never claimed before
    }
    
    const lastClaim = new Date(player.lastDailyAt);
    const now = new Date();
    const hoursSince = (now.getTime() - lastClaim.getTime()) / (1000 * 60 * 60);
    
    return hoursSince >= 24;
  },

  // Get time until next claim in human readable format
  getTimeUntilNextClaim() {
    const store = this.$store.app;
    
    if (!store.hasPlayer()) return 'Login requerido';
    const player = store.p();
    
    if (!player.lastDailyAt) {
      return 'Disponible ahora';
    }
    
    const lastClaim = new Date(player.lastDailyAt);
    const nextClaim = new Date(lastClaim.getTime() + (24 * 60 * 60 * 1000));
    const now = new Date();
    
    if (now >= nextClaim) {
      return 'Disponible ahora';
    }
    
    const msRemaining = nextClaim.getTime() - now.getTime();
    const hoursRemaining = Math.floor(msRemaining / (1000 * 60 * 60));
    const minutesRemaining = Math.floor((msRemaining % (1000 * 60 * 60)) / (1000 * 60));
    
    if (hoursRemaining > 0) {
      return `${hoursRemaining}h ${minutesRemaining}m`;
    } else {
      return `${minutesRemaining}m`;
    }
  },

  // Calculate daily coins reward
  getDailyCoins() {
    const store = this.$store.app;
    
    if (!store.hasPlayer()) return 0;
    const level = store.p().level || 1;
    const baseCoins = 100;
    const levelBonus = Math.floor(level * 25);
    return baseCoins + levelBonus;
  },

  // Get level bonus amount
  getLevelBonus() {
    const store = this.$store.app;
    
    if (!store.hasPlayer()) return 0;
    const level = store.p().level || 1;
    return Math.floor(level * 25);
  },

  // Claim daily reward
  async claimDailyReward() {
    if (this.loading) return;
    
    if (!this.canClaim()) {
      this.error = 'Ya reclamaste tu recompensa de hoy';
      this.clearMessages();
      return;
    }

    this.loading = true;
    this.error = null;
    this.successMessage = null;

    try {
      const response = await api.post('/player/daily-claim', {});
      
      // Update player data in store
      const store = this.$store.app;
      store.updatePlayer(response.player);
      
      // Save to recent claims
      this.saveRecentClaim(response.reward);
      
      // Show success message
      this.successMessage = response.message;
      
      // Show notification with reward details
      store.addNotification(
        `🎁 ${response.reward.description}`,
        'success'
      );

      this.clearMessages();

    } catch (error) {
      console.error('Daily claim error:', error);
      
      if (error.message.includes('ALREADY_CLAIMED')) {
        this.error = 'Ya reclamaste tu recompensa de hoy';
      } else {
        this.error = error.message || 'Error al reclamar recompensa diaria';
      }
      
      this.clearMessages();
    } finally {
      this.loading = false;
    }
  },

  // Format claim date for display
  formatClaimDate(dateString) {
    try {
      const date = new Date(dateString);
      const now = new Date();
      const diffTime = Math.abs(now - date);
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      
      if (diffDays === 0) {
        return 'Hoy';
      } else if (diffDays === 1) {
        return 'Ayer';
      } else if (diffDays < 7) {
        return `Hace ${diffDays} días`;
      } else {
        return date.toLocaleDateString('es-ES', { 
          day: 'numeric', 
          month: 'short' 
        });
      }
    } catch {
      return 'Fecha inválida';
    }
  },

  // Get next reset time (for debugging/info)
  getNextResetTime() {
    const now = new Date();
    const tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);
    
    return tomorrow.toLocaleString('es-ES');
  }
});